import { render, staticRenderFns } from "./ItemComponent.vue?vue&type=template&id=d938f6a8&scoped=true"
import script from "./ItemComponent.vue?vue&type=script&lang=js"
export * from "./ItemComponent.vue?vue&type=script&lang=js"
import style0 from "./ItemComponent.vue?vue&type=style&index=0&id=d938f6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d938f6a8",
  null
  
)

export default component.exports